import React from "react";
import clsx from "clsx";
import "./chat-box-bar.styles.scss";
import {
	useSelectableChatBoxListState,
	useSelectableChatBoxListDispatch,
} from "../SelectableChatBoxList";
import { useChatBoxListUIController, useChatBoxViewContext } from "../../contexts";

//@ts-ignore
import { ReactComponent as StickerIcon } from "../../../assets/icons/Sticker.svg";
//@ts-ignore
import { ReactComponent as PhotoIcon } from "../../../assets/icons/Photo.svg";
//@ts-ignore
import { ReactComponent as FileIcon } from "../../../assets/icons/File.svg";
//@ts-ignore
import { ReactComponent as ScreenCaptureIcon } from "../../../assets/icons/ScreenCapture.svg";
//@ts-ignore
import { ReactComponent as ContactIcon } from "../../../assets/icons/Contact.svg";
//@ts-ignore
import { ReactComponent as ReminderIcon } from "../../../assets/icons/Reminder.svg";
//@ts-ignore
import { ReactComponent as RTFIcon } from "../../../assets/icons/RTF.svg";
//@ts-ignore
import { ReactComponent as MoreIcon } from "../../../assets/icons/More.svg";
//@ts-ignore
import { ReactComponent as OutlineTrashIcon } from "../../../assets/icons/OutlineTrash.svg";

import { PopoverTrigger } from "../Popover";
import { StickerPanel } from "../StickerPanel";

export interface ChatBoxBarProps {
	className?: string;
}

const BlockName = "chat-box-bar";
const ClassNames = {
	Block: BlockName,
	Modifiers: {},
	Elements: {
		LeftChatBoxBar: `${BlockName}__left-chat-box-bar`,
		RightChatBoxBar: `${BlockName}__right-chat-box-bar`,
		SelectedCount: `${BlockName}__selected-count`,
		Toolbar: `${BlockName}__toolbar`,
		ToolbarItem: `${BlockName}__toolbar-item`,
		ToolbarButton: `${BlockName}__toolbar-button`,
		ToolbarButtonGroup: `${BlockName}__toolbar-button-group`,
		ToolbarItemDelete: `${BlockName}__toolbar-item-delete`,
		SelectedCountNum: `${BlockName}__selected-count-num`,
	},
} as const;

export type ChatBoxBarComponent = React.FC<ChatBoxBarProps> & {
	ClassNames: typeof ClassNames;
};

export const ChatBoxBar = ((props: ChatBoxBarProps) => {
	const { selectedItemsMap } = useSelectableChatBoxListState();
	const dispatch = useSelectableChatBoxListDispatch();
	const controller = useChatBoxListUIController();

	const selectedCount = React.useMemo(() => {
		return Object.keys(selectedItemsMap).length;
	}, [selectedItemsMap]);

	const handleDeleteSelectedItemsClick = () => {
		const deletedMessageItems = Object.values(selectedItemsMap);
		
		controller.deleteMessagesByCliMsgIds( deletedMessageItems).finally(() => {
			dispatch({
				type: "clear-all-selected-items",
			});
		});
	};

	return (
		<div className={clsx(ChatBoxBar.ClassNames.Block, props.className)}>
			<div className={ChatBoxBar.ClassNames.Elements.LeftChatBoxBar}>
				<ul className={ChatBoxBar.ClassNames.Elements.Toolbar}>
					<StickerPanel>
						<PopoverTrigger>
							<li className={ChatBoxBar.ClassNames.Elements.ToolbarItem}>
								<button
									className={ChatBoxBar.ClassNames.Elements.ToolbarButton}
									title="Gửi Sticker"
								>
									<StickerIcon className="w-6 h-6 text-gray-800" />
								</button>
							</li>
						</PopoverTrigger>
					</StickerPanel>

					<li className={ChatBoxBar.ClassNames.Elements.ToolbarItem}>
						<button
							className={ChatBoxBar.ClassNames.Elements.ToolbarButton}
							title="Gửi hình ảnh"
						>
							<PhotoIcon className="w-6 h-6 text-gray-800" />
						</button>
					</li>
					<li className={ChatBoxBar.ClassNames.Elements.ToolbarItem}>
						<button
							className={ChatBoxBar.ClassNames.Elements.ToolbarButton}
							title="Đính kèm File, Sản phẩm"
						>
							<FileIcon className="w-6 h-6 text-gray-800" />
						</button>
					</li>
					<li className={ChatBoxBar.ClassNames.Elements.ToolbarItem}>
						<button
							className={ChatBoxBar.ClassNames.Elements.ToolbarButton}
							title="Chụp không kèm cửa sổ Zalo (⌥ + ⌘ + S)"
						>
							<ScreenCaptureIcon className="w-6 h-6 text-gray-800" />
						</button>
					</li>
					<li className={ChatBoxBar.ClassNames.Elements.ToolbarItem}>
						<button
							className={ChatBoxBar.ClassNames.Elements.ToolbarButton}
							title="Gửi danh thiếp"
						>
							<ContactIcon className="w-6 h-6 text-gray-800" />
						</button>
					</li>
					<li className={ChatBoxBar.ClassNames.Elements.ToolbarItem}>
						<button
							className={ChatBoxBar.ClassNames.Elements.ToolbarButton}
							title="Tạo nhắc hẹn"
						>
							<ReminderIcon className="w-6 h-6 text-gray-800" />
						</button>
					</li>
					<li className={ChatBoxBar.ClassNames.Elements.ToolbarItem}>
						<button
							className={ChatBoxBar.ClassNames.Elements.ToolbarButton}
							title="Định dạng tin nhắn (Cmd + Shift + X)"
						>
							<RTFIcon className="w-6 h-6 text-gray-800" />
						</button>
					</li>
					<li className={ChatBoxBar.ClassNames.Elements.ToolbarItem}>
						<button
							className={ChatBoxBar.ClassNames.Elements.ToolbarButton}
							title="Tùy chọn thêm"
						>
							<MoreIcon className="w-6 h-6 text-gray-800" />
						</button>
					</li>
				</ul>
			</div>
			{selectedCount > 0 && (
				<div className={ChatBoxBar.ClassNames.Elements.RightChatBoxBar}>
					<div className={ChatBoxBar.ClassNames.Elements.SelectedCount}>
						<span className={ChatBoxBar.ClassNames.Elements.SelectedCountNum}>
							{selectedCount}
						</span>{" "}
						Đã chọn
					</div>
					<ul className={ChatBoxBar.ClassNames.Elements.Toolbar}>
						<li
							className={clsx(
								ChatBoxBar.ClassNames.Elements.ToolbarItem,
								ChatBoxBar.ClassNames.Elements.ToolbarItemDelete,
							)}
						>
							<button
								className={ChatBoxBar.ClassNames.Elements.ToolbarButton}
								onClick={handleDeleteSelectedItemsClick}
							>
								<OutlineTrashIcon className="w-6 h-6" />
							</button>
						</li>
					</ul>
				</div>
			)}
		</div>
	);
}) as ChatBoxBarComponent;
ChatBoxBar.ClassNames = ClassNames;
